<template>
  <section>
    <div class="section_title">
      <img src="@/assets/img/settings_sub.jpg" />
      <h1 class="">通知書郵送設定変更</h1>
    </div>
    <div id="MailSetting" class="detail-cart my-5 border box-p-20">
      <h2 class="mb-2 text-left">支払通知書郵送設定（有料）</h2>
      <div class="c-radio mb-5">
        <div class="radio_box d-flex">
          <!-- 初期表示時、当該ログイン会員の「通知書類郵送設定」の検索結果により、「希望する」「希望しない」ラジオボタンをチェック状態とする -->
          <div class="mr-5">
            <input
              type="radio"
              id="notice01"
              v-model="info"
              value="1"
              class="mt-n1"
            />
            <label for="notice01">希望する</label>
          </div>
          <div>
            <input
              type="radio"
              id="notice02"
              v-model="info"
              value="0"
              class="mt-n1"
              checked
            />
            <label for="notice02">希望しない</label>
          </div>
        </div>
      </div>
      <p>
        2025年10月お支払分より、郵送にてお届けする支払通知書（紙）が有料となりました。<br />
        「希望する」を選択された場合、会員さまには「１通あたり330円（税込）」の発行手数料をご負担いただきます。<br />
        何卒、ご理解賜りますようお願い申し上げます。<br />
        <span style="color:red;font-weight: bold;">※変更設定は翌月度より適用されます。</span>
      </p>
    </div>
    <div class="my-5 text-center">
      <button
        class="btn d-inline-block"
        style="width: 300px"
        v-on:click="putData"
      >
        上記の内容に変更する
      </button>
    </div>
    <div class="mb-5 text-center">
      <router-link to="/settings" class="btn d-inline-block"
        >会員情報を変更へ戻る</router-link
      >
    </div>
  </section>
</template>
<script>
import Request from "@/modules/Request";
import Message from "@/modules/Message";
let request = new Request();
export default {
  data() {
    return {
      info: "0",
    };
  },
  mounted() {
    this.getCurrentNotice();
  },
  methods: {
    getCurrentNotice() {
      console.log("getCurrentNotice");
      let requestParams = request.createParams(
        "webMdlMemberInfo",
        "getNotice",
        []
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          this.info = data.CurrentNotice;
        });
    },
    putData() {
      console.log(this.info);
      let postParams = [this.info];
      let requestParams = request.createParams(
        "webMdlMemberInfo",
        "putNotice",
        postParams
      );
      request
        .create()
        .post("", requestParams)
        .then(() => {
          Message.success().fire({
            position: "center",
            showConfirmButton: true,
            timer: null,
            toast: false,
            title: "変更しました",
          });
          this.$router.push("/settings/notice");
        });
    },
  },
};
</script>

<style>
.detail-cart div.c-radio div.radio_box div {
  min-width: 20%;
  margin-bottom: 10px;
}
.detail-cart div.c-radio div.radio_box label {
  font-weight: bold;
  cursor: pointer;
  font-size: 1.125em;
}
</style>
